import classNames from 'classnames'

export function BreakoutTable({
  className,
  children,
  testId,
  onScroll,
  ref,
  size = 'default',
}: {
  className?: string
  children?: React.ReactNode
  testId?: string
  onScroll?: (event: React.UIEvent<HTMLTableElement>) => void
  ref?: React.Ref<HTMLTableElement>
  /** `small` renders 14px cells with tighter padding, for tables inside cards. */
  size?: 'default' | 'small'
}) {
  return (
    <table
      className={classNames(
        'breakout-table',
        size === 'small' && 'breakout-table-sm',
        className
      )}
      data-testid={testId}
      onScroll={onScroll}
      ref={ref}
    >
      {children}
    </table>
  )
}
